import cn from 'classnames';

import type { EntityOverviewBlock as EntityOverviewBlockType, EntityOverviewField } from '../types';
import { BlockEmptyState } from './BlockEmptyState';

// ─────────────────────────────────────────────
// EntityOverviewBlock — 公司基本信息
// Figma node: 10426-25580
// 外层背景 #F8F8F7，圆角 8px；行 padding 12px gap 12px；
// label 固定宽 140px，颜色 #262626，字号 14px；
// 偶数行（0-indexed 奇数）背景 rgba(229,229,229,0.2)；
// 行间分隔线 1px #E5E5E5；URL 显示为蓝色可点击链接
// ─────────────────────────────────────────────
export function EntityOverviewBlock({ block }: { block: EntityOverviewBlockType }) {
  const fields = block.fields ?? [];
  // 兼容旧版 items 字段（不在标准类型中，做类型断言访问）
  const legacyItems = ((block as unknown as Record<string, unknown>).items as EntityOverviewField[] | undefined) ?? [];
  const rows = fields.length > 0 ? fields : legacyItems;

  if (rows.length === 0) return <BlockEmptyState label="公司信息" />;

  const isUrl = (val: string) => val.startsWith('http://') || val.startsWith('https://');

  return (
    <div className="flex flex-col bg-[#F8F8F7] rounded-[8px] overflow-hidden">
      {rows.map((row, idx) => (
        <div key={idx}>
          <div
            className={cn('flex items-center gap-3 px-3 py-3', {
              'bg-[rgba(229,229,229,0.2)]': idx % 2 === 1,
            })}
          >
            <span className="w-[140px] shrink-0 text-[14px] text-[#262626] leading-[1.5]">{row.label}</span>
            {isUrl(row.value) ? (
              <a
                href={row.value}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[14px] text-[#2563EB] underline leading-[1.5] flex-1 min-w-0 break-all"
              >
                {row.value}
              </a>
            ) : (
              <span className="text-[14px] text-[#262626] leading-[1.5] flex-1 min-w-0">{row.value}</span>
            )}
          </div>
          {idx < rows.length - 1 && <div className="h-px bg-[#E5E5E5]" />}
        </div>
      ))}
    </div>
  );
}
